const USER_ROLE = {
  SUPER_ADMIN: "Administrador",
  COORDINATOR: "Coordinador",
  ENTREPRENEUR: "Emprendedor",
  ADVISER: "Asesor"
};

export default USER_ROLE;
